<script lang="ts">
  import { Typography } from "./ui/typography";
  import AccountIcon from "@/components/icons/Accounts.svelte";
  import BoostingIcon from "@/components/icons/Boosting.svelte";
  import TeammateIcon from "@/components/icons/Teammate.svelte";
  import ItemsIcon from "@/components/icons/Items.svelte";
  import { onMount } from "svelte";
  import { localizeUrl } from "@/helpers/localization";

  interface Props {
    game?: string;
  }

  let { game = "" }: Props = $props();

  interface Section {
    name: string;
    path: string;
    icon: any;
  }

  interface GameLink {
    key: string;
    href: string;
    label: string;
    image: string;
    sections: Section[];
  }

  const gameLinks: GameLink[] = [
    {
      key: "lol",
      href: localizeUrl("/league-of-legends/boosting/"),
      label: "League of Legends",
      image: "/images/lol.svg",
      sections: [
        {
          name: "Accounts",
          path: localizeUrl("/league-of-legends/smurf-accounts/"),
          icon: AccountIcon
        },
        {
          name: "Boosting",
          path: localizeUrl("/league-of-legends/boosting/"),
          icon: BoostingIcon
        }
        // { name: "Teammates", path: "/boosting/lol/teammates/", icon: TeammateIcon},
        // { name: "Items", path: "/boosting/lol/items/", icon: ItemsIcon }
      ]
    },
    {
      key: "valorant",
      href: localizeUrl("/valorant/boosting/"),
      label: "Valorant",
      image: "/images/val.svg",
      sections: [
        {
          name: "Boosting",
          path: localizeUrl("/valorant/boosting/"),
          icon: BoostingIcon
        }
      ]
    },
    {
      key: "cs2",
      href: localizeUrl("/cs2/boosting/"),
      label: "Counter-Strike 2",
      image: "/images/cs2.svg",
      sections: [
        {
          name: "Boosting",
          path: localizeUrl("/cs2/boosting/"),
          icon: BoostingIcon
        }
      ]
    }
  ];

  let currentGame = gameLinks.find((gameLink) => gameLink.key === game);
  let selectedSection: string | null = $state(null);

  onMount(() => {
    const path = window.location.pathname;
    selectedSection =
      currentGame?.sections.find((section) => path.includes(section.path))
        ?.name || null;
  });

  function selectSection(section: Section): void {
    selectedSection = section.name;
    window.location.href = section.path;
  }
</script>

<div>
  <div
    color="none"
    class="relative mx-auto flex w-full max-w-[1200px] items-center justify-between rounded-b-[8px] border border-dark-gray bg-theme-black px-4">
    {#if currentGame}
      <div class="flex items-center gap-2">
        <img src={currentGame.image} alt={currentGame.label} class="h-6 w-6" />
        <Typography variant="large" weight="medium">
          {currentGame.label}
        </Typography>
      </div>
    {/if}
    <div class="flex items-center gap-2">
      {#if currentGame}
        <div role="listbox" class="flex">
          {#each currentGame.sections as section}
            <a
              role="option"
              aria-selected={selectedSection === section.name}
              class="flex flex-col items-center gap-1.5
                p-4 text-medium-gray transition-all duration-200
                aria-selected:inline-flex
                aria-selected:bg-[radial-gradient(49.61%_38.39%_at_50%_100%,rgba(155,48,255,0.20)_0%,rgba(18,18,18,0.00)_100%)]
                aria-selected:text-white lg:flex-row"
              onclick={() => selectSection(section)}
              href={section.path}>
              <section.icon
                class={selectedSection === section.name
                  ? "h-6 w-6 text-accent"
                  : "h-6 w-6"} />
              <span class="text-xs lg:text-base">{section.name}</span>
            </a>
          {/each}
        </div>
      {/if}
    </div>
  </div>
</div>
